import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaExclamationTriangle, FaInfoCircle, FaShieldAlt, FaExternalLinkAlt, FaBalanceScale, FaUserShield, FaEnvelope, FaMapMarkerAlt, FaCommentAlt, FaSyncAlt } from 'react-icons/fa';
import { BsShieldExclamation } from 'react-icons/bs';
import Layout from '../components/layout/Layout';
import './LegalPages.css';

const Disclaimer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <Layout>
      <Container className="legal-page">
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="text-center mb-5">
              <FaExclamationTriangle size={48} className="text-warning mb-3" />
              <h1 className="page-title">Disclaimer</h1>
              <p className="last-updated">
                <FaInfoCircle className="me-2" />
                Last Updated: July 20, 2025
              </p>
            </div>
            
            <section className="mb-5">
              <p>
                The information provided on UniTrade (the "Service") is for general informational purposes only. 
                All information on the Service is provided in good faith, however, we make no representation 
                or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, 
                reliability, availability, or completeness of any information on the Service.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="section-title">
                <BsShieldExclamation className="me-2 text-warning" />
                1. No Warranty
              </h2>
              <p>
                The Service is provided "AS IS" and "AS AVAILABLE" without any warranties of any kind, 
                either express or implied, including but not limited to, implied warranties of 
                merchantability, fitness for a particular purpose, or non-infringement.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="section-title">
                <FaShieldAlt className="me-2 text-danger" />
                2. Limitation of Liability
              </h2>
              <p>
                In no event shall UniTrade, nor its directors, employees, partners, agents, suppliers, 
                or affiliates, be liable for any indirect, incidental, special, consequential or punitive 
                damages, including without limitation, loss of profits, data, use, goodwill, or other 
                intangible losses, resulting from your access to or use of or inability to access or 
                use the Service.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="section-title">
                <FaExternalLinkAlt className="me-2 text-info" />
                3. External Links
              </h2>
              <p>
                The Service may contain links to external websites that are not provided or maintained 
                by or in any way affiliated with UniTrade. Please note that we do not guarantee the 
                accuracy, relevance, timeliness, or completeness of any information on these external 
                websites.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="section-title">
                <FaBalanceScale className="me-2 text-primary" />
                4. Fair Use Disclaimer
              </h2>
              <p>
                The Service may contain copyrighted material the use of which has not always been 
                specifically authorized by the copyright owner. We are making such material available 
                for criticism, comment, news reporting, teaching, scholarship, or research.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="section-title">
                <FaUserShield className="me-2 text-success" />
                5. Personal Responsibility
              </h2>
              <p>
                You acknowledge that you are using the Service at your own risk. The information 
                provided is not a substitute for professional advice. You are solely responsible for 
                your use of any information contained on the Service.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="section-title">
                <FaCommentAlt className="me-2 text-info" />
                6. Testimonials
              </h2>
              <p>
                The Service may contain testimonials by users of our products and/or services. These 
                testimonials reflect the real-life experiences and opinions of such users. However, the 
                experiences are personal to those particular users, and may not necessarily be 
                representative of all users of our products and/or services.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="section-title">
                <FaSyncAlt className="me-2 text-primary" />
                7. Changes to This Disclaimer
              </h2>
              <p>
                We reserve the right to modify this disclaimer at any time. We will provide notice of 
                any changes by posting the new disclaimer on this page and updating the "Last Updated" 
                date at the top of this page.
              </p>
            </section>

            <section>
              <h2 className="section-title">
                <FaEnvelope className="me-2" />
                8. Contact Us
              </h2>
              <p>
                If you have any questions about this Disclaimer, please contact us at:
              </p>
              <address>
                <div className="d-flex align-items-center mb-2">
                  <FaEnvelope className="me-2" />
                  <strong>Email:</strong> support@unitradegh.com
                </div>
                <div className="d-flex align-items-center">
                  <FaMapMarkerAlt className="me-2" />
                  <strong>Address:</strong> University of Energy and Natural Resources, Sunyani, Ghana
                </div>
              </address>
            </section>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default Disclaimer;
